import { useEffect } from 'react'

import { getAccessToken } from '../services/authentication'
import { onUnauthenticated } from '../utils/onUnauthenticated'

export const useRequireAuth = (): { isAuthenticated: boolean } => {
  const hasToken = !!getAccessToken()

  useEffect(() => {
    if (!hasToken) {
      onUnauthenticated()
    }
  }, [hasToken])

  return { isAuthenticated: hasToken }
}
